// stores/courseStore.ts
import { create } from 'zustand';
import apiClient from '../apiSetup/axiosInterceptor';

interface Subject {
  subject_id: string;
  subject_name: string;
}

interface Course {
  course_id: string;
  institute_id: string;
  name: string;
  title: string;
  description: string | null;
  status: 'active' | 'inactive';
  subjects: Subject[];
  created_at: string; // ISO-like format "YYYY-MM-DD HH:mm:ss"
}

interface Pagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}

interface ApiResponse {
  success: boolean;
  data: Course[];
  pagination: Pagination;
}

interface CourseState {
  courses: Course[] | null;
  pagination: Pagination | null;
  loading: boolean;
  error: string | null;
  fetchCourses: (status?: 'active' | 'inactive') => Promise<void>;
  clearError: () => void;
}

export const useCourseStore = create<CourseState>((set) => ({
  courses: null,
  pagination: null,
  loading: false,
  error: null,
  clearError: () => set({ error: null }),
  fetchCourses: async (status?) => {
    set({ loading: true, error: null });
    try {
      const params = new URLSearchParams();
      if (status) params.set('status', status);

      const response = await apiClient.get<ApiResponse>(`/v1/courses?${params}`);
      console.log(response.data)
      set({
        courses: response.data.data,
        pagination: response.data.pagination,
        loading: false,
      });
    } catch (err: any) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Failed to load courses';
      set({ error: message, loading: false });
    }
  },
}));